import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../utility/Helper';
import { UserUpload } from 'src/app/modules/admin/user-upload-management/user-upload.model';


@Pipe({
  name: 'formatFileName'
})
export class FormatFileNamePipe implements PipeTransform {
  transform(row: UserUpload): string | undefined {
    if (row?.dataType === 'URL') {
      return row.fileName;
    }

    if (!row?.fileName) {
      return row?.fileName;
    }

    const extension = Helper.getFileExtension(row.fileName)[0];

    return row.fileName
      // remove extension
      .replace(new RegExp(`\\.${extension}$`), '')
      // remove last 6 chars
      .slice(0, -6)
      // add extension back
      .concat('.', extension);
  }
}
